import { Injectable } from '@angular/core';
import {
  IFormFieldErrorMessages,
  IFormMasterBuilder,
  IRouter,
} from 'i2g-ng-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { EmailService } from 'i2g-ng-utils';

@Injectable()
export class EmailLoginBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    EMAIL_ADDRESS: 'email_address',
    PASSWORD: 'password',
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _emailService: EmailService,
    private _translateService: TranslateService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  buildForm(): FormGroup {
    const formKeys = this.FORM_KEYS;

    return this._formBuilder.group({
      [formKeys.EMAIL_ADDRESS]: [
        '',
        [
          Validators.required,
          Validators.maxLength(250),
          this._emailService.emailValidatorFn(),
        ],
      ],
      [formKeys.PASSWORD]: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(250),
        ],
      ],
    });
  }

  buildPasswordMinLengthErrorMessages(): IFormFieldErrorMessages {
    return {
      min: {
        message: 'FORM.PASSWORD.MIN_LENGTH_ERROR',
      },
    };
  }

  buildForgotPasswordRoute(): IRouter {
    return {
      label: this._translateService.instant('LOGIN.FORGOT_PASSWORD'),
      route: ['/forgot-password'],
      trackingAction: this._trackingActionBuilder.buildButtonTapped(
        'forgot_password',
        TrackingScreenNamesEnum.account_sign_in
      ),
    };
  }
}
